export class WhiteGoodItemModel { 
    item_no: number
    item_code: string
    item_desc: string 
    constructor( 
        item_no: number,
        item_code: string,
        item_desc: string
    ) { 
        this.item_no = item_no
        this.item_code = item_code
        this.item_desc = item_desc
    }
}

export class OrderItemListModel { 
    order_no: number
    order_code: string 
    constructor( 
        order_no: number,
        order_code: string 
    ) { 
        this.order_no = order_no
        this.order_code = order_code 
    }
} 